import { PopupBody } from '../types/PopupBody';

const closeFinishBtns = ['Volver a la llamada', 'Finalizar Videoconsulta'];

const accpetCancelBtns = ['Cancelar', 'Aceptar'];

const acceptCancelRecordBtns = ['Rechazo', 'Acepto'];

const lateMedicBtns = ['Esperar al Médico', 'Finalizar Videoconsulta'];

const cidAndIsMedic = {
  cid: 0,
  isMedic: 0,
};

const waitToReconnect = {
  bodyS:
    'Alguno de los socios podría volver a conectarse. En caso de que no se conecte niguno dentro de unos minutos, presione el botón finalizar Videoconsulta.',
  bodyM:
    'El médico podría volver a conectarse. En caso de que no se conecte dentro de unos minutos, presione el botón finalizar Videoconsulta.',
};

export const WaitMedicPopupBody: PopupBody = {
  ...cidAndIsMedic,
  title: 'El médico se desconectó de la llamada',
  body: waitToReconnect.bodyM,
  btns: closeFinishBtns,
};

export const WaitSocioPopupBody: PopupBody = {
  ...cidAndIsMedic,
  title: 'No quedan socios en la llamada',
  body: waitToReconnect.bodyS,
  btns: closeFinishBtns,
};

export const networkMedicPopupBody: PopupBody = {
  ...cidAndIsMedic,
  title: 'El médico perdió su conexión a internet',
  body: waitToReconnect.bodyM,
  btns: closeFinishBtns,
};

export const networkSocioPopupBody: PopupBody = {
  ...cidAndIsMedic,
  title: 'El socio perdió su conexión a internet',
  body: waitToReconnect.bodyS,
  btns: closeFinishBtns,
};

export const FinishPopupBody: PopupBody = {
  ...cidAndIsMedic,
  title: 'Vas a finalizar la Videoconsulta',
  body: '¿Estás seguro de que quieres finalizar la Videoconsulta?',
  btns: closeFinishBtns,
};

export const PermissionsPopupBody: PopupBody = {
  ...cidAndIsMedic,
  title: 'No tienes permisos para usar la cámara y el micrófono',
  body: 'Para poder realizar una Videoconsulta necesitas tener habilitados los permisos del navegador, una vez activos recarga el navegador para continuar a la Videoconsulta.',
  link: 'https://support.google.com/chrome/answer/2693767?hl=es-419&co=GENIE.Platform%3DDesktop&oco=1',
};

export const lateMedic: PopupBody = {
  ...cidAndIsMedic,
  title: 'El médico se encuentra demorado',
  body: 'El médico aún no se ha unido a la videoconsulta, la misma permanece en espera hasta que se conecte para iniciar la atención.',
  btns: lateMedicBtns,
};

export const ConsentRecordingBody: Partial<PopupBody> = {
  title: 'Grabación de Videoconsulta',
  body: 'Para mejorar y auditar el servicio, esta videoconsulta puede ser grabada. ¿Está usted de acuerdo?',
  btns: acceptCancelRecordBtns,
};
